import { render, staticRenderFns } from "./ReadDocuments.handler.vue?vue&type=template&id=bc3e9be4&"
import script from "./ReadDocuments.handler.vue?vue&type=script&lang=ts&"
export * from "./ReadDocuments.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports